'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var Button = require('@narvar/nth-block-button');
var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SecondaryButton = _ref => {
  let {
    children,
    selected,
    ...props
  } = _ref;
  const {
    buttonsSecondaryDefault,
    buttonsSecondaryHover
  } = nthHookTheme.useTheme();
  const [hovered, setHovered] = React.useState(false);
  const styles = hovered ? {
    color: buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color,
    borderColor: buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color,
    filter: 'brightness(90%)'
  } : {
    color: buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.color,
    borderColor: buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.color
  };
  return /*#__PURE__*/React__default["default"].createElement(Button__default["default"], _extends__default["default"]({
    outline: true
  }, props, {
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      borderWidth: '1px',
      borderStyle: 'solid',
      backgroundColor: buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.backgroundColor,
      ...(selected ? {
        outline: `1px solid ${(buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.color) || '#000'}`
      } : {}),
      ...styles
    }
  }), children);
};
var SecondaryButton$1 = nthHookTheme.withThemeProvider(SecondaryButton, {
  themeTokens: ['buttonsSecondaryDefault', 'buttonsSecondaryHover']
});

exports["default"] = SecondaryButton$1;
